import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { List } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

const ChapterList = forwardRef(({ children, className, ...props }, ref) => {
  const classes = useStyles();

  return (
    <List
      ref={ref}
      className={clsx(classes.root, className)}
      disablePadding
      {...props}
    >
      {children}
    </List>
  );
});

ChapterList.propTypes = {
  /**
   * Items to be displayed within the list. Should always be a <li>
   */
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default ChapterList;
